export default "__VITE_ASSET__d352cff4__"